import EmployerDashboard from "../../employer/pages/dashboard/EmployerDashboard";
import Jobs from "../../user/pages/Jobs";
import TrainingDetail from "../../user/pages/TrainingDetail";
import UserTrainings from "../../user/pages/UserTrainings";
import TrainingProgram from "../../employer/pages/TrainingProgram";
import AddJobPosting from "../../employer/pages/AddJobPosting";
import JobDetail from "../../user/pages/JobDetail";
import AddTraining from "../../employer/pages/AddTraining";
import EmployerProfile from "../../employer/pages/dashboard/EmployerProfile";
import EmployerProfileUpdate from "../../employer/pages/dashboard/EmployerProfileUpdate";
import ChangePassword from "../../components/ChangePassword";
import Applicants from "../../admin/pages/Applicants";
import ViewApplicantProfile from "../../user/pages/dashboard/ViewApplicantProfile";
import AddRole from "../../employer/pages/AddRole";
import AddSponsor from "../../employer/pages/Sponsors ";
import AllSkillsReports from "../../admin/pages/dashboard/AllSkillsReports";
import Invoices from "../../employer/pages/Invoices";
import EmployerJobListing from "../../employer/pages/EmployerJobListing";
import JobApplicants2 from "../../components/employer/Jobs/JobApplicants2";
import ShortlistedApplicants from "../../employer/pages/ShortlistedApplicants";
import CreateEmployerTeam from "../../employer/pages/CreateEmployerTeam";
import EmployerTeams from "../../employer/pages/EmployerTeams";
import EmployerRolesAndPermissions from "../../employer/pages/EmployerRolesAndPermissions";
import CreateRoleAndPermissions from "../../employer/pages/CreateRoleAndPermissions";

const PrivateEmployerRoutes = [
    {path: '/employer/dashboard', exact: true, element: EmployerDashboard},
    {path: '/employer/reports', exact: true, element: AllSkillsReports},
    {path: '/employer/job-listing/', exact: true, element: EmployerJobListing},
    {path: '/employer/job-listing/:jobId', exact: true, element: JobApplicants2},
    {path: '/employer/jobs', exact: true, element: Jobs},
    {path: '/employer/training-detail/:slug', exact: true, element: TrainingDetail},
    {path: '/employer/trainings-programs', exact: true, element: UserTrainings},
    {path: '/employer/my-programs', exact: true, element: TrainingProgram},
    {path: '/employer/create-job-posting', exact: true, element: AddJobPosting},
    {path: '/employer/sponsor-course/:curseId', exact: true, element: AddSponsor},
    {path: '/employer/job-detail/:slug', exact: true, element: JobDetail},
    {path: '/employer/create-training', exact: true, element: AddTraining},
    {path: '/employer/profile', exact: true, element: EmployerProfile},
    {path: '/employer/profile-update', exact: true, element: EmployerProfileUpdate},
    {path: '/employer/change-password', exact: true, element: ChangePassword},
    {path: '/employer/applicants', exact: true, element: Applicants},
    {path: '/employer/invoices', exact: true, element: Invoices},
    {path: '/employer/add-role/:role', exact: true, element: AddRole},
    {path: '/employer/applicant/:uuid', exact: true, element: ViewApplicantProfile},
    {path: '/employer/jobs2', exact: true, element: JobApplicants2},
    {path: '/employer/applicants/shortlisted', exact: true, element: ShortlistedApplicants},
    {path: '/employer/create-admin', exact: true, element: CreateEmployerTeam},
    {path: '/employer/admins', exact: true, element: EmployerTeams},
    {path: '/employer/role-permissions', exact: true, element: EmployerRolesAndPermissions},
    {path: '/employer/create-role-permissions', exact: true, element: CreateRoleAndPermissions},
]

export default PrivateEmployerRoutes
